export enum CalibrationlogoEnum {
    Turkak = '/assets/logo/turkaklogo.png',
    NAC = '/assets/logo/naclogo.png'
}